import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[mvs-widget-config-component-directive]',
    standalone: false
})
export class WidgetConfigComponentDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
